import React from 'react';

import { PageWrapper } from '../page';
import { AdminPanelSidebar } from './sidebar';

export type Props = {
  children: React.ReactNode;
  title?: string;
};

export const AdminPageWrapper: React.FC<Props> = (props) => {
  let { children, title } = props;

  return (
    <PageWrapper title={title}>
      <div className="block md:flex">
        <div>
          <AdminPanelSidebar />
        </div>
        <div className="px-8 py-6 w-full min-h-screen">
          {children}
          <div className="h-48"></div>
        </div>
      </div>
    </PageWrapper>
  );
};
